import React, { useEffect, useState } from "react";
import MainLayout from "../../../components/layout/mainLayout/mainLayout";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  invoiceTemplateUpload,
  settingsInvoiceTemplateCreate,
  settingsInvoiceTemplateEdit,
  settingsInvoiceTemplateList,
  settingsStateList,
} from "../../../redux/actions/settingsActions";
import { Field, Form, Formik, useFormikContext } from "formik";
import * as Yup from "yup";
import InputField from "../../../components/form/inputField/inputField";
import SuccessPopup from "../../../components/popups/SuccessPopup";
import ErrorPopup from "../../../components/popups/ErrorPopup";
import StateListTable from "../../../components/tables/stateListTable";
import searcher from "../../../assets/icons/searchInput.svg";
import InvoiceTemplatesListTable from "../../../components/tables/invoice-templates-table";
import { Document, Page } from "react-pdf";
import eye from "../../../assets/icons/viewEye.svg";
import PdfView from "../../../components/modals/pdfView";
import { documentPhoto1 } from "../../../redux/actions/customerActions";
import reupload from "../../../assets/icons/reUpload.svg";
import { pdfChecker } from "../../../components/utilites/helper";
import upload from "../../../assets/icons/uploadImg.svg";
import ImageViewModal from "../../../components/modals/customer/image-view-modal";

const InvoiceTemplatePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);
  const search = queryParamsData.get("search") ?? "";
  const [page, setPage] = useState(page_no ? page_no : 1);
  const [disable, setDisable] = useState(true);
  const [editEnable, setEditEnable] = useState(false);
  const [stateListData, setStateListData] = useState("");

  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState();
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState();
  const [loading, setLoading] = useState(false);
  const [catchedErrorPopup, setCatchedErrorPopup] = useState(false);
  const [catchedErrorMsg, setCatchedErrorMsg] = useState();
  const [userData, setUserData] = useState(null);
  const [openPdf, setOpenPdf] = useState(false);
  const [pdfFileUrl, setPdfFileUrl] = useState(null);
  const [filename, setFileName] = useState(null);
  const [imageModal, setImageModal] = useState(false);
  const [imageTitleData, setImageTitleData] = useState("");
  const [imageUrlData, setImageUrlData] = useState("");
  const [uploadImage, setuploadImage] = useState(null);

  const user_type = localStorage.getItem("userType");
  useEffect(() => {
    if (user_type === "super_admin") {
      const permissionData = JSON.parse(localStorage.getItem("permissions"));
      const permissionValue = permissionData?.find(
        (item) => item?.module_name === "Settings" && item
      );

      setUserData(permissionValue);
    }
  }, [user_type]);

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  useEffect(() => {
    fetchStateList();
  }, [page, search]);

  const initialValues = {
    id: "",
    name: "",
    image_url: "",
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().trim().required("Required"),
  });

  const onSubmit = (values, { resetForm }) => {
    setuploadImage(null);
    if (!editEnable) {
      dispatch(
        settingsInvoiceTemplateCreate(
          {
            name: values?.name,
            image_url: uploadImage ?? values?.image_url,
          },
          onSuccess,
          onError
        )
      );
    } else {
      dispatch(
        settingsInvoiceTemplateEdit(
          {
            id: values?.id,
            name: values?.name,
            image_url: uploadImage ?? values?.image_url,
          },
          onEditSuccess,
          onEditError
        )
      );
    }

    resetForm({
      values: {
        name: "",
        code: "",
        image_url: "",
      },
    });
  };

  const timeOutFnc = () => {
    setShowSuccessPopup(false);
    fetchStateList();
  };

  const onSuccess = (data) => {
    const str = data.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowSuccessMsg(str_modify);
    setShowSuccessPopup(true);
    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    setShowErrorPopup(true);
  };

  const onEditSuccess = (data) => {
    fetchStateList();
    setEditEnable(false);
  };

  const onEditError = (err) => {
    console.log(err);
  };

  const fetchStateList = () => {
    setLoading(true);
    dispatch(
      settingsInvoiceTemplateList(
        { page, search },
        onGetTemplateSuccess,
        onGetTemplateError
      )
    );
  };

  const onGetTemplateSuccess = (data) => {
    console.log(data);
    setLoading(false);
    setStateListData(data?.data?.data);
  };

  const closeCatchedErrPopup = () => {
    setCatchedErrorPopup(false);
  };

  const onGetTemplateError = (err) => {
    console.log(err);
    setLoading(false);
    setCatchedErrorPopup(true);
    setCatchedErrorMsg(err.data.message);
  };

  const FormEnableCheck = () => {
    const {
      values: { name },
    } = useFormikContext();
    useEffect(() => {
      if (name.trim() != "") {
        setDisable(false);
      } else setDisable(true);
    }, [name]);
    return null;
  };

  const editSetForm = (item, index, setFieldValue) => {
    setuploadImage(null);
    setEditEnable(true);
    setFieldValue("id", item.id);
    setFieldValue("name", item.name);
    setFieldValue("code", item.code);
    setFieldValue("image_url", item.image_url);
  };

  const UploadTemplate = (e) => {
    console.log(e.target.files[0]);
    dispatch(
      invoiceTemplateUpload(
        e.target.files[0],
        onImageUploadSuccess,
        onImageUploadError
      )
    );
  };
  const onImageUploadSuccess = async (data) => {
    console.log(data, "onImageUploadSuccess");
    setuploadImage(data?.data?.data?.filePath);
  };
  const onImageUploadError = (err) => {};

  return (
    <MainLayout breadCrumb="ADMIN  /  settings  /  Invoice template">
      <SuccessPopup show={showSuccessPopup} title={showSuccessMsg} />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
      <ErrorPopup
        show={catchedErrorPopup}
        title={catchedErrorMsg}
        handleClose={closeCatchedErrPopup}
      />

      <PdfView
        show={openPdf}
        handleClose={() => setOpenPdf(false)}
        pdfUrl={pdfFileUrl}
        filename={filename}
      />
      <ImageViewModal
        show={imageModal}
        ShowClose={() => setImageModal(false)}
        imageTitleData={imageTitleData}
        imageUrlData={imageUrlData}
      />
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ errors, setFieldValue, values }) => (
          <Form>
            <FormEnableCheck />

            <>
              {(user_type == "super_admin" && userData?.write) ||
              user_type == "admin" ? (
                <>
                  <div className="basic-details-container my-3 mt-4 mx-4 my-auto d-flex align-items-center ">
                    <label className="basic-title mx-2 mb-1">
                      invoice template
                    </label>
                  </div>
                  <div className="form-width ms-4 ps-3 py-1">
                    <div className="my-2">
                      <InputField
                        id={"name"}
                        label={"Name"}
                        labelColor={"color_262c3d"}
                        type={"text"}
                        placeholder={"Enter name"}
                        name={"name"}
                        value={values.name}
                      />
                    </div>
                    <div className="my-2">
                      <div className="upload-image-label-container d-flex justify-content-between">
                        <label className="my-1 color_747F9E">
                          Invoice Image
                        </label>
                        {(uploadImage || values?.image_url) && (
                          <span className="d-flex align-items-center">
                            <img src={reupload} />
                            <label className="my-1 Medium_Purple fs_12 ms-1 fw_700">
                              RE-UPLOAD
                              <input
                                className="upload-document-input"
                                type="file"
                                name="image_url"
                                accept="image/*, application/pdf"
                                onChange={(e) => UploadTemplate(e)}
                              />
                            </label>
                          </span>
                        )}
                      </div>

                      <div
                        className="manufacturer-doc-upload-container"
                        style={{ position: "relative" }}
                      >
                        {uploadImage || values?.image_url ? (
                          <>
                            <img
                              className="image-upload"
                              src={
                                uploadImage ? uploadImage : values?.image_url
                              }
                            />
                            <div
                              className="w-100"
                              style={{
                                position: "absolute",
                                zIndex: "55",
                                top: "0",
                                maxWidth: "450px",
                              }}
                            >
                              <div
                                className="manufacturer-doc-upload-container"
                                style={{
                                  backgroundColor: "rgb(38, 44, 61, 0.6 )",
                                }}
                              >
                                <div
                                  className="align-items-center"
                                  style={{
                                    position: "absolute",
                                    zIndex: "55",
                                    top: "43%",
                                    left: "40%",
                                  }}
                                >
                                  <img src={eye} className="mb-2" />
                                  <button
                                    type="button"
                                    className="fs_16 fw_600"
                                    style={{
                                      backgroundColor: "transparent",
                                      color: "#E7E5FF",
                                      border: "none",
                                    }}
                                    onClick={() => {
                                      setImageModal(true);
                                      setImageTitleData(values?.name);
                                      setImageUrlData(
                                        uploadImage
                                          ? uploadImage
                                          : values?.image_url
                                      );
                                    }}
                                  >
                                    VIEW
                                  </button>
                                </div>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <label htmlFor="logo" className="w-100 text-center">
                              <div
                                style={{ height: "12rem" }}
                                className={`d-flex align-items-center justify-content-center `}
                              >
                                <div className="d-flex flex-column align-items-center justify-content-center">
                                  <img
                                    src={upload}
                                    width="50px"
                                    height="50px"
                                  />
                                  <span className="color_#262C3D pt-2 fs_14 fs_lg_12">
                                    Drag your image here, or
                                    <span className="Medium_Purple fw_700 ms-1">
                                      Browse
                                    </span>
                                  </span>
                                  <label className="color_747f9e pt-1 fs_10">
                                    Supports: JPEG and PNG images only.{" "}
                                    <span className="color_black">
                                      (2MB Max, 540X540px Resolution)
                                    </span>
                                  </label>
                                </div>
                              </div>
                            </label>
                            <input
                              type="file"
                              name="upload"
                              id="logo"
                              style={{ display: "none" }}
                              onChange={(e) => UploadTemplate(e)}
                            />
                          </>
                        )}
                      </div>
                    </div>

                    <div
                      className="d-flex justify-content-end"
                      style={{ maxWidth: "450px" }}
                    >
                      {!editEnable ? (
                        <button
                          type="submit"
                          className="add-button fs_18 fw_700 fs_sm_12 px-4 py-2 w-50"
                          style={{ maxWidth: "210px" }}
                          disabled={disable}
                        >
                          Create
                        </button>
                      ) : (
                        <button
                          type="submit"
                          className="add-button fs_14 fw_700 fs_sm_12 px-4 py-2 w-50"
                          style={{ maxWidth: "210px" }}
                        >
                          Edit
                        </button>
                      )}
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
              <div className="basic-details-container my-3 mt-4 mx-4 my-auto d-flex align-items-center ">
                <label className="basic-title mx-2 mb-1">
                  Invoice Templates List
                </label>
              </div>
              <div className="mt-4 inside-table-container mx-4">
                <div className=" my-2 search-container ">
                  <div className="search-box w-50 d-flex align-items-center p-2 ms-3 m-1 mb-2">
                    <img className="styled-SVG" src={searcher} />
                    <input
                      value={search}
                      className="search-input fs_14 fw_400 px-2 text-dark"
                      type="text"
                      placeholder="Search invoice template here by invoice template name..."
                      onChange={(e) => {
                        navigate(
                          `/settings/invoice-template?page=1${
                            e.target.value ? `&search=${e.target.value}` : ""
                          }`
                        );
                      }}
                    />
                  </div>
                </div>
                <div className="px-1 position-relative">
                  <InvoiceTemplatesListTable
                    stateListData={stateListData}
                    setFieldValue={setFieldValue}
                    editSetForm={editSetForm}
                    setPage={setPage}
                    page={page}
                    search={search}
                    loading={loading}
                  />
                </div>
              </div>
            </>
          </Form>
        )}
      </Formik>
    </MainLayout>
  );
};

export default InvoiceTemplatePage;
